import { createSlice } from '@reduxjs/toolkit';

import ReduxState from 'store/ReduxState';

export interface PostPurchaseStepState {
  currentStep: number;
}

export const initialPostPurchaseState: PostPurchaseStepState = {
  currentStep: 0,
};

export const postPurchaseSlice = createSlice({
  name: 'postPurchase',
  initialState: initialPostPurchaseState,
  reducers: {
    goToNextPostPurchaseStep: (state) => {
      state.currentStep = state.currentStep + 1;
    },
  },
});

export const getPostPurchaseCurrentStep = (
  state: Pick<ReduxState, 'postPurchase'>,
): number => {
  return state.postPurchase.currentStep;
};

export const { goToNextPostPurchaseStep } = postPurchaseSlice.actions;

export default postPurchaseSlice.reducer;
